<div class="background-video" *ngIf="videoUrl">
    <div class="row" style="height: 100%; direction: rtl;">
        <div class=" videoCell" >
<!--            <video autoplay muted loop id="myVideo" [muted]="true" controls>-->
<!--                <source [src]="videoUrl" type="video/mp4">-->
<!--                Your browser does not support HTML5 video.-->
<!--            </video>-->
<!--            https://youtube.com/shorts/lUQhRuZqYRE?feature=share-->
            <iframe class="videoStage"  src="https://www.youtube.com/embed/lUQhRuZqYRE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class=" descriptionCell" >
            <h3 style="font-size: 2.0em;">{{title}}</h3>
            <p style="font-size: 1.09em; text-align: justify; overflow-y: auto">{{description}}</p>
        </div>
    </div>

</div>
